<template>
	<v-layout row v-if="!dataSame && contestId">
		<v-flex xs6>
			<old-version-marker/>
			<project-choose-actions
				:contest-id="contestId"
				:actions.sync="old"
				:new-version="current"
				:readonly="true"
				:number-of-modules="numberOfModules"
				:module-number="moduleNumber"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<project-choose-actions
				:contest-id="contestId"
				:actions.sync="current"
				:old-version="old"
				:readonly="true"
				:number-of-modules="numberOfModules"
				:module-number="moduleNumber"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
  import OldVersionMarker from "@/view/logged/offer/compareComponents/oldVersionMarker";
  import NewVersionMarker from "@/view/logged/offer/compareComponents/NewVersionMarker";
  import ProjectChooseActions from "@/view/logged/project/components/ProjectChooseActions";

	export default {
		name: "CompareProjectActions",
		components: {ProjectChooseActions, NewVersionMarker, OldVersionMarker},
		computed: {
			dataSame () {
				if (this.old === undefined || this.current === undefined) {
					return false;
				}

				let oldCopy = JSON.parse(JSON.stringify(this.old));
				let currentCopy = JSON.parse(JSON.stringify(this.current));

				//id zmieniają się wraz z zapisywaniem projektu, więc nie możemy po nich porównywać
				for (let action of oldCopy) {
					action.id = 0;
				}

				for (let action of currentCopy) {
					action.id = 0;
				}

				let comparisonResult = JSON.stringify(oldCopy) === JSON.stringify(currentCopy);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			contestId: {},
			moduleNumber: {
				default: "",
			},
			numberOfModules: {
				default: 0,
			},
		}
	};
</script>

<style scoped>

</style>
